<div
  class="tab-container mt-4 p-10"
  *ngIf="agencyDefaultCommissions() && adminSettingsStore?.tenantDetails() as tenantDetails"
>
  <h3 class="app">Commission Split</h3>
  <p class="mt-3">
    For each premium range, customize the commission percentage split available between MGA and Retail Agency (up to
    {{ tenantDetails.commission }}%
  </p>

  <div class="commission-table">
    <div class="row" *ngFor="let commission of agencyDefaultCommissions()">
      <div class="left">
        <strong>Premium Range:</strong> ${{ commission.premiumMin }} -
        {{ commission.premiumMax ? '$' + commission.premiumMax : 'No limit' }}
      </div>
      <div class="right">
        <span
          >MGA Commission: {{ minZero((tenantDetails?.commission ?? 0) - (commission?.agentCommission ?? 0)) }}%</span
        >
        <span style="font-weight: bold">Retail Agency Commission: </span> {{ commission.agentCommission }}%
      </div>
    </div>
  </div>

  <h3 class="app mt-[35px]">MGA Fees</h3>
  <p class="mt-3">For each premium range, customize the flat rate MGA fee applied to quotes</p>

  <div class="commission-table">
    <div class="row" *ngFor="let mgaFee of mgaFees()">
      <div class="left">
        <strong>Premium Range:</strong> ${{ mgaFee.premiumMin }} -
        {{ mgaFee.premiumMax ? '$' + mgaFee.premiumMax : 'No limit' }}
      </div>
      <div class="right">
        <span style="font-weight: bold">MGA Fee: </span>
        <span> ${{ mgaFee.amount }}</span>
      </div>
    </div>
  </div>

  <h3 class="app mt-4">Other Fees</h3>
  <p class="mt-3">Optionally add other flat rate fees applied to quotes</p>

  <div class="mt-3">
    <div class="grid" style="grid-template-columns: 200px 1fr; gap: 16px; font-weight: 400">
      <div class="pb-4 underline">Fee Title</div>
      <div class="pb-4 underline">Fee Amount ($)</div>
    </div>
    <div class="grid" style="grid-template-columns: 200px 1fr; gap: 16px" *ngFor="let adhocFee of adhocFees()">
      <div class="pb-2">{{ adhocFee.name }}</div>
      <div class="pb-2">{{ adhocFee.amount }}</div>
    </div>
  </div>
  <p class="mt-3">To customize your fees, connect with your Program Administrator to modify these settings.</p>
</div>
